import "./style.scss";

import React, { FC, useContext, useEffect, useState } from "react";
import { updateNotification, updateNotificationSingle } from "features/notifications";

import { DocumentsContext } from "features/documents";
import { ReactComponent as IconNotification } from "../../assets/img/icons/icon_bell2.svg";
import Notification from "../Notification/Notification";
import { UserContext } from "features/account";
import { useNavigate } from "react-router";
import {NotificationContext} from "features/notifications";
import {useLocation} from "react-router-dom";
import Modal from "shared/ui/Modal";


interface NotificationsListProps {
    title?: string;
    fromDashBoard?: boolean;
    filter: 'id-assistant' | 'id-locker' | 'identity-documents' | 'all'; // tabNotificationActions recordID
    showSetAllAsSeenText?: boolean;
    notificationTab?: string;
    limit?: number;
}

const NotificationsList: FC<NotificationsListProps> = ({
    title,
    filter,
    fromDashBoard = true,
    showSetAllAsSeenText = false,
    notificationTab,
    limit
}) => {

    const location = useLocation(); // Hook pour récupérer l'URL actuelle
    const {
        notificationsUnseen,
        fetchNotificationsByActions,
        notifications,
    } = useContext(DocumentsContext);

    const { currentNotificationTab, setCurrentNotificationTab} = useContext(NotificationContext);

    let navigate = useNavigate();

    const { userType } = useContext(UserContext);


    useEffect(() => {
        fetchNotificationsByActions(currentNotificationTab, limit);
    }, [notificationTab, currentNotificationTab]);

    useEffect(() => {
        if (location.pathname.includes('notifications')) {
            fetchNotificationsByActions('all', limit);
        } else {
            fetchNotificationsByActions(filter, limit);
        }
    }, [location.pathname]);

    const tryUpdateNotificationSingle = async (idNotif: number) => {
        try {
            await updateNotificationSingle(userType, idNotif);
        } catch (error) {
            console.log(error);
        } finally {
            console.log("TrustfullReasonList - RefreshDocuments")
            fetchNotificationsByActions(filter, limit);
        }
    };

    const updateNotificationsList = async () => {
        try {
            await updateNotification(userType);
        } catch (error) {
            console.log(error);
        } finally {
            fetchNotificationsByActions(filter, limit);
        }
    };

    const [showModal, setShowModal] = useState<boolean>(false);



    return (
        <>
            {fromDashBoard && (
              <div className="notifications__header pointer">
                  <div className="shadow notifications__header__count d-flex justify-content-center align-items-center flex-row bg-primary-70 rounded-lg py-2"
                       onClick={() => {
                           setShowModal(true);
                       }}
                  >
                      <IconNotification
                        fill={"#dff3ee"}
                        width={24}
                        height={24}
                      />
                      <span className={`rounded-full text-light bg-error-40 ${notificationsUnseen > 9 ? 'p-2': 'p-1'} px-3 shadow`}>{notificationsUnseen}</span>
                  </div>
              </div>
            )}
            {showModal &&
              <Modal
                onClose={() => setShowModal(false)} isOpen={showModal} title={"Notifications"} infoModal={true}
                type={"info"}>
                  <div >
                      <hr className={'my-4'}/>
                      <ul className="notifications">
                          <div>
                              {notifications &&
                                notifications?.length > 0 &&
                                notifications
                                  .map((notification) => (
                                    <Notification
                                      key={notification.id}
                                      notification={notification}
                                      updateNotification={tryUpdateNotificationSingle}
                                    />
                                  ))}
                          </div>
                      </ul>
                      {showSetAllAsSeenText && (
                        <p
                          className="notifications__button"
                          onClick={() => updateNotificationsList()}>
                            Marquer tous comme lus
                        </p>
                      )}
                      {!showSetAllAsSeenText && (
                        <p
                          className="notifications__button"
                          onClick={() => navigate(`${userType !== 'partner' ? '/particuliers' : '/professionnels'}/notifications`
                          )}
                        >
                            Afficher toutes les notifications
                        </p>
                      )}

                  </div>
              </Modal>
            }

        </>
    );
};

export default NotificationsList;
